import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DomainService {
  private companyDomain: string | null = null;

  constructor() { }

  setDomain(domain: string): void {
    this.companyDomain = domain;
  }

  getDomain(): string | null {
    return this.companyDomain;
  }

  clearDomain(): void {
    this.companyDomain = null;
  }
}
